import { render } from "./InputGoals.vue?vue&type=template&id=0d87a467"
import script from "./InputGoals.vue?vue&type=script&lang=js"
export * from "./InputGoals.vue?vue&type=script&lang=js"

import "./InputGoals.vue?vue&type=style&index=0&id=0d87a467&lang=scss"
script.render = render

export default script